module.exports = __webpack_public_path__ + "assets/img/10.57fc59c7.png";